import { Component, OnDestroy, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { CupraModelVersionModel } from '../../../models/cupramodelversion';
import { SeatFileFidelizationProductsCupraModel } from 'src/app/models/SeatFileFidelizationProductsCupra';
import { BudgetBuilderService } from 'src/app/services/budgetbuilder.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CupraBudgetService } from 'src/app/services/budget.service';
import { Options } from 'ng5-slider';
import { ToastrService } from 'ngx-toastr';
import { Select2OptionData } from 'ng-select2';
import { SharedService } from 'src/app/services/shared.service';
import { CupraBudgetModel } from '../../../models/cuprabudget';
import { ActivatedRoute, Router } from '@angular/router';
import { GsDistributorAddressDTO } from 'src/app/models/common';
import * as $ from 'jquery';


@Component({
  templateUrl: './cupra-date-form.component.html',
  styleUrls: ['./cupra-date-form.component.scss']
})

export class CupraDateFormComponent implements OnInit {

  dataform: FormGroup;
  submitted = 0;
  searchModel: SeatFileFidelizationProductsCupraModel;
  budget: CupraBudgetModel;
  pathServer = environment.urlServer;
  idBudget: string;
  distrisList: GsDistributorAddressDTO[] = [];
  showForm = false;
  loaded = false;

  constructor(
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private budgetService: CupraBudgetService) { }



  ngOnInit() {

    this.idBudget = this.route.snapshot.paramMap.get('id');

    const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^\d+$/;

    this.dataform = new FormGroup({
      CcName: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      CcSurname: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      CcEmail: new FormControl(null, [Validators.required, Validators.maxLength(50), Validators.pattern(mailRegex)]),
      CcPhone: new FormControl(null, [Validators.required, Validators.pattern(phoneRegex), Validators.max(999999999), Validators.min(111111111)]),
      CcIdDistributor: new FormControl(null, [Validators.required]),
      Bastidor: new FormControl(null),
      Matricula: new FormControl(null, [Validators.required, Validators.maxLength(20)])
    });

    this.budgetService.get(this.idBudget).subscribe(res => {
      this.budget = res;
      this.loaded = true;
      this.showForm = !this.budget.CcDate;

      this.dataform.patchValue(this.budget);

      if (this.budget.Bastidor != null) {
        this.dataform.controls.Bastidor.setValidators([Validators.required, Validators.max(30)]);
        this.dataform.controls.Bastidor.updateValueAndValidity();
      }

      this.dataform.controls.CcIdDistributor.setValue(this.budget.IdDistributor != null ? this.budget.IdDistributor : null);

      if (this.budget.IdDistributor == null) {

        this.sharedService.GetCupraDistributorByProvince(this.budget.IdProvince).subscribe(res => {

          this.distrisList = res;


        });

      }

    });
  }


  get f() { return this.dataform.controls; }



  saveCupraCare() {

    this.submitted = 1;

    if (!this.dataform.valid) return;

    this.budget.CcName = this.dataform.controls.CcName.value;
    this.budget.CcSurname = this.dataform.controls.CcSurname.value;
    this.budget.CcEmail = this.dataform.controls.CcEmail.value;
    this.budget.CcPhone = this.dataform.controls.CcPhone.value;
    this.budget.Matricula = this.dataform.controls.Matricula.value;
    this.budget.Bastidor = this.dataform.controls.Bastidor.value;
    this.budget.CcIdDistributor = this.dataform.controls.CcIdDistributor.value;
    this.budget.CcDate = true;


    this.budgetService.put(this.budget.IdBudget, this.budget).subscribe(res => {

      this.showForm = false;

      this.budgetService.SendBudgetEMR(this.budget.IdBudget).subscribe(res => {

        this.toastr.success('Tu solicitud de cita previa se ha realizado correctamente.');
      }, (err) => {

        Swal.fire({
          toast: true,
          showConfirmButton: false,
          icon: 'error',
          title: '',
          text: 'Error al crear la cita'
        });
      });

    }, (err) => {
      Swal.fire({
        toast: true,
        showConfirmButton: false,
        icon: 'error',
        title: '',
        text: 'Error al crear la cita'
      });
    });
  }

  selectDistri(idDistributor) {

    this.dataform.controls.CcIdDistributor.setValue(idDistributor);

    $('#distri' + idDistributor).addClass('bg-dark');
    $('#distri' + idDistributor).css('color', 'white');

    this.distrisList.filter(o => o.IdDistributor != idDistributor).forEach(elem => {
      $('#distri' + elem.IdDistributor).removeClass('bg-dark');
      $('#distri' + elem.IdDistributor).css('color', 'black');
    });

  }

}
